import 'whatwg-fetch';
import { middle_dev, middle_key_val, middle_env } from 'config';
import { couponsWeb_controller } from 'config';

const authHeader = new Headers();
authHeader.append('Accept', 'application/json');
authHeader.append('Content-Type', 'application/json');

export default class CouponService{
    static getListPublic() {
        /*
        *   @publicCoupons
        *   Devuelve lista de cupones públicos
        *   
        *   OUT     |   data            |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        return fetch(`${middle_dev}/${couponsWeb_controller}/coupons?ambito=${middle_env}`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static getListPrivate() {
        /*
        *   @privateCoupons
        *   Devuelve lista de cupones privados, accesibles son con una sesión iniciada
        *   
        *   OUT     |   data            |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/coupons`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static getCouponDetail(idCoupon = '') {
        /*
        *   @couponDetail
        *   Devuelve el detalle completo de un cupón
        *   
        *   OUT     |   data            |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/couponDetail?idCoupon=${idCoupon}`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
    static getCouponDetailMaterial(idCoupon = '') {
        /*
        *   @couponDetail
        *   Devuelve el detalle completo de un cupón
        *   
        *   OUT     |   data            |   object
        */
        authHeader.set('X-API-KEY', middle_key_val);
        authHeader.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('sessionData')).token}`);
        return fetch(`${middle_dev}/${couponsWeb_controller}/auth/couponDetailMaterial?idCoupon=${idCoupon}`,{ headers: authHeader }).then((data) => {
            return data.json()
        })
    }
}